import React, { createContext, useContext, useMemo } from "react";
import { createPlatformClient, type PlatformClient } from "./PlatformClient";

export type { PlatformClient, Result } from "./PlatformClient";

const PlatformContext = createContext<PlatformClient | null>(null);

export function PlatformProvider({ children }: { children: React.ReactNode }) {
    const client = useMemo(
        () => createPlatformClient(process.env.REACT_APP_PLATFORM_API ?? ""),
        [],
    );
    return <PlatformContext.Provider value={client}>{children}</PlatformContext.Provider>;
}

export function usePlatformAPI(): PlatformClient {
    const client = useContext(PlatformContext);
    if (!client) throw new Error("usePlatformAPI must be used within a PlatformProvider");
    return client;
}
